'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (process.env.NODE_ENV !== 'production') {
        return
      }
      if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) {
        console.warn(
          '[PostHog] NEXT_PUBLIC_POSTHOG_KEY is not set — analytics and feature flags are disabled'
        )
        return
      }
      if (!posthog.__loaded) {
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
          api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
          capture_pageview: false, // handled manually for SPA navigation
          capture_pageleave: true,
          capture_exceptions: true,
          before_send: (event) => {
            if (event?.event === '$exception') {
              const list = event.properties?.$exception_list as
                | Array<{ value?: string }>
                | undefined
              const msg = list?.[0]?.value ?? ''
              if (msg.startsWith('ResizeObserver loop')) return null
              if (msg.includes('Failed to load chunk') || msg.includes('Loading chunk')) return null
              // Defence in depth: drop any exception whose message looks like
              // an HTML document. These produce garbage `[IN-APP]` frames
              // parsed out of `<a href>` strings in the body.
              if (msg.startsWith('<!DOCTYPE') || msg.includes('<html')) return null
            }
            return event
          },
        })
      }
    }
  }, [])

  return <PHProvider client={posthog}>{children}</PHProvider>
}
